export enum StreamTier {
  Active = 'active',
  Visible = 'visible',
  Background = 'background',
}

export interface StreamTierConfig {
  maxWidth: number;
  maxHeight: number;
  maxFps: number;
  sendVideo: boolean;
  maxHops: number;
}

export const TIER_CONFIGS: Record<StreamTier, StreamTierConfig> = {
  [StreamTier.Active]: {
    maxWidth: 1280,
    maxHeight: 720,
    maxFps: 30,
    sendVideo: true,
    maxHops: 3,
  },
  [StreamTier.Visible]: {
    maxWidth: 640,
    maxHeight: 360,
    maxFps: 15,
    sendVideo: true,
    maxHops: 4,
  },
  [StreamTier.Background]: {
    maxWidth: 0,
    maxHeight: 0,
    maxFps: 0,
    sendVideo: false,
    maxHops: 5,
  },
};
